export const ignoreLargeCalls = [
  // New accounts/locations UI
  'getAccountsBySearch',
  'getAccountsByFocusedSearch',
  'getAccountsByRecentSearch',
  'getLocations',
  // Route manager
  'getRouteStopsUnassigned',
  'getRouteStops',
  'getDailyLane',
  'getRouteStopsGeojson',
  // Billing
  'getBillingCreateInvoiceList',
  'getBillingInvoiceList',
  'getBillingSentInvoiceList',
  'getBillingPaymentList',
  'getBillingARList',
  // Groups
  'getInvoiceGroupDetails',
  'getPaymentGroupDetails',
  'getAccountGroupDetails',
  // Configured services
  'getAllConfiguredServices',
  // Work orders
  'getWorkOrderListSummary',
  'getWorkOrderList',
]

export const ignoreFrustratingCalls = ['getAllAccountNotes', 'getLocationsNotesCount', 'getPortalUsers']

export const ignoreLargeState = {
  accounts: undefined,
  locations: undefined,
  CustomerDetails: undefined,
  apiReducer: undefined,
}
